// react
// navigate
import { createSlice } from '@reduxjs/toolkit';
// formik
// @material-ui
// icons
// hooks
// @types
import { AxiosResponseModel } from '../../@types/base';
import { DashboardCountsModel, DashboardModel } from '../../@types/dashboard';
// redux
import { CONSTS } from './const';
import { dispatch } from '../store';
// routes
// components
// utils
import axios from '../../utils/axios';
// constants
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import {
  CameraTypeResultModel,
  LocationTypeResultModel
} from '../../@types/constants';

// ----------------------------------------------------------------------

type ConstantsState = {
  locationTypeListError: boolean;
  isLocationTypeListLoading: boolean;
  locationTypeList: string[];

  cameraTypeListError: boolean;
  isCameraTypeListLoading: boolean;
  cameraTypeList: string[];
};

const initialState: ConstantsState = {
  locationTypeListError: false,
  isLocationTypeListLoading: false,
  locationTypeList: [],

  cameraTypeListError: false,
  isCameraTypeListLoading: false,
  cameraTypeList: []
};

const slice = createSlice({
  name: 'constants',
  initialState,
  reducers: {
    // ----------------------------------------------------------------------
    // LOCATIONTYPELIST
    // ----------------------------------------------------------------------

    // START LOCATION TYPE LIST LOADING
    startLocationTypeListLoading(state) {
      state.isLocationTypeListLoading = true;
    },

    // HAS ERROR LOCATION TYPE LIST
    hasErrorLocationTypeList(state, action) {
      state.isLocationTypeListLoading = false;
      state.locationTypeListError = action.payload;
    },

    // GET ALL LOCATION TYPES LIST
    getAllLocationTypesSuccess(state, action) {
      state.isLocationTypeListLoading = false;
      state.locationTypeList = action.payload;
    },

    // ----------------------------------------------------------------------
    // CAMERAYPELIST
    // ----------------------------------------------------------------------

    // START AMERA TYPE LIST LOADING
    startCameraTypeListLoading(state) {
      state.isCameraTypeListLoading = true;
    },

    // HAS ERROR AMERA TYPE LIST
    hasErrorCameraTypeList(state, action) {
      state.isCameraTypeListLoading = false;
      state.cameraTypeListError = action.payload;
    },

    // GET ALL AMERA TYPES LIST
    getAllCameraTypesSuccess(state, action) {
      state.isCameraTypeListLoading = false;
      state.cameraTypeList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {} = slice.actions;

// ----------------------------------------------------------------------
// LOCATIONTYPELIST

export async function getAllLocationTypesWithReturn() {
  dispatch(slice.actions.startLocationTypeListLoading());
  try {
    const response: AxiosResponseModel<LocationTypeResultModel> = await axios
      .get(CONSTS.CONSTANTS_GET_GET_ALL_LOCATIONTYPES)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.getAllLocationTypesSuccess(response.data?.data));
    } else {
      dispatch(slice.actions.getAllLocationTypesSuccess([]));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorLocationTypeList(error));
    return error.response.data;
  }
}

export async function getAllCameraTypesWithReturn() {
  dispatch(slice.actions.startCameraTypeListLoading());
  try {
    const response: AxiosResponseModel<CameraTypeResultModel> = await axios
      .get(CONSTS.CONSTANTS_GET_GET_ALL_CAMERATYPES)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.getAllCameraTypesSuccess(response.data?.data));
    } else {
      dispatch(slice.actions.getAllCameraTypesSuccess([]));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorCameraTypeList(error));
    return error.response.data;
  }
}

// ----------------------------------------------------------------------
